import styled from 'styled-components';

import MdIcon from '~/shared/components/mdIcon';

export const Container = styled.div`
  z-index: 100;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const Content = styled.div`
  text-align: center;
  background: #fff;
  -webkit-overflow-scrolling: touch;
  padding: ${(props) => (props.isPdfShowing ? '0px' : '30px')};
  border-radius: ${(props) => (props.isPdfShowing ? '0px' : '6px')};
  position: relative;
  width: ${(props) => props.widthContainer};
  height: ${(props) => props.heightContainer};
  margin: ${(props) => (props.isPdfShowing ? '0px' : '50px 12px 0 12px')};
  overflow: ${(props) => (props.isPdfShowing ? 'scroll' : 'unset')};
  @media (max-width: 330px) {
    width: ${(props) => (props.isPdfShowing ? '100%' : '300px')};
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => (props.isPdfShowing ? '25px 0px 67px 20px' : '25px')};
  position: fixed;
  top: 0;
  height: '80px';
  background: white;
  width: ${(props) => props.headerSize};
  z-index: 999;
`;

export const IconContainer = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  margin-right: 10px;
  margin-top: ${(props) => (props.isPdfShowing ? '-5px' : '-25px')};
`;

export const StyledIcon = styled(MdIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const Title = styled.span`
  text-align: left;
  font-size: 20px;
  letter-spacing: 0px;
  color: #262b45;
  opacity: 1;
  font-weight: 500;
`;

export const TabsPdfsContainer = styled.div`
  display: flex;
  position: fixed;
  overflow: scroll;
  z-index: 999;
  flex: 1;
  border-top: 1px solid ${(props) => props.theme.palette.gray4};
  border-bottom: 1px solid ${(props) => props.theme.palette.gray4};
  top: 64px;
  background: white;
  z-index: 999;
  width: 100%;
`;

export const TabsPdfsItem = styled.div`
  cursor: pointer;
  display: flex;
  height: 50px;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) =>
    props.isEnabled ? props.theme.palette.gray2 : props.theme.palette.gray3};
  border-bottom: 3px solid
    ${(props) =>
      props.isEnabled
        ? props.theme.palette.primary.contrastText
        : props.theme.palette.primary.main};
  text-transform: uppercase;
  width: 150px;
  min-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${(props) => props.theme.palette.gray4};

  @media (max-width: 500px) {
    :nth-last-child(1) {
      min-width: ${(props) => props.itensQt > 2 && '200px'};
      padding-right: ${(props) => props.itensQt > 2 && '60px'};
    }
  }
`;

export const ContentPdfChildren = styled.div`
  -webkit-overflow-scrolling: touch;
  padding-top: ${(props) => (props.isPdfShowing ? '115px' : 'unset')};
  padding-bottom: ${(props) => (props.isPdfShowing ? '175px' : 'unset')};
  @media (min-width: 800px) {
    padding-bottom: ${(props) => (props.isPdfShowing ? '10px' : 'unset')};
  }
`;
